import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { StructuredListing } from '@hz-design-system/web-ui';

import formatPrice from '../../utils/formatPrice';
import { getLargeImageUrl } from '../../utils/getImageUrls';
import { trackGAEvent } from '../../utils/gaTracking';
import { TFranchiseDealerItem } from 'types/TFranchiseDealersItem';
import { GA_TRACK_EVENTS_ACTIONS } from '../../utils/constants';

type TItemsProps = {
  item: TFranchiseDealerItem;
  className?: string;
  suppressZeroCents?: boolean;
  index: number;
};

const FRANCHISE_DEALERS_CAROUSEL_LABEL = 'FranchiseDealersCarousel';

const DealerItem = ({ item, className, suppressZeroCents, index }: TItemsProps) => {
  const { t } = useI18nContext();
  const imageUrl = item.picture?.url;
  const formattedImageUrl = imageUrl && imageUrl.trim() ? getLargeImageUrl(imageUrl, item.imageSizes) : '';

  const handleClick = () => {
    trackGAEvent(GA_TRACK_EVENTS_ACTIONS.Click, FRANCHISE_DEALERS_CAROUSEL_LABEL, {
      value: index + 1,
    });
  };

  return (
    <StructuredListing
      className={className}
      price={formatPrice(item.price, false, t, suppressZeroCents)}
      title={item.title}
      imageSrc={formattedImageUrl || ''}
      alt={`${item.title} ${t('sellerOtherItems.imageAltText')}`}
      imageLoading="lazy"
      decoding="async"
      isMaskedLink={item.thinContent}
      linkProps={{ href: item.url, onClick: handleClick }}
    />
  );
};

export default DealerItem;
